// VIBRANIAM-SPACE v2 - FullscreenButton.jsx
// Toggles fullscreen on whatever element targetRef points to. Icon-only by
// default (compact chrome), or pass label for a text button.

import React from 'react';
import useFullscreen from '../hooks/useFullscreen.js';

export default function FullscreenButton({ targetRef, label, className, touchSize = false }) {
  const { isFullscreen, toggle } = useFullscreen(targetRef);
  const sizing = touchSize ? 'min-h-[44px] min-w-[44px] px-2.5 text-[12px]' : 'px-2 py-1 text-[10px]';

  return (
    <button
      type="button"
      onClick={toggle}
      title={isFullscreen ? 'Esci da schermo intero' : 'Schermo intero'}
      className={`flex items-center justify-center gap-1 rounded bg-ink-600 hover:bg-ink-500 ${sizing} ${className || ''}`}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" className="shrink-0">
        {isFullscreen ? (
          <path d="M9 3v4a2 2 0 0 1-2 2H3M21 9h-4a2 2 0 0 1-2-2V3M3 15h4a2 2 0 0 1 2 2v4M15 21v-4a2 2 0 0 1 2-2h4" />
        ) : (
          <path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M3 16v3a2 2 0 0 0 2 2h3" />
        )}
      </svg>
      {label && <span>{label}</span>}
    </button>
  );
}
